import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import pako from "pako";
import * as actionFunction from "../../../actions/common";
import $ from "jquery";
import Header from "../../../Header";
import HeaderMob from "../../../HeaderMob";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import ContentLoader from "../../customer/contentLoader";
import moment from "moment";
import Skeleton from "react-loading-skeleton";

class ProductStoreDetailsNew extends Component {
  constructor(props) {
    super(props);
    var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? this.decrypt(localStorage.getItem("encdata"), 0)
      : "";
    this.state = {
      apiUrl: this.decryptconfigdata("apiUrl"),
      studioUrl: this.decryptconfigdata("studioUrl"),
      userAuthKey: has_local_data ? localdata.user_key : "",
      billing_details: [],
      cards_list: [],
      applications: [],
      account_manager: "",
      content_analytics: [],
      get_billing_api: 0,
      get_content_api: 0,
      get_template_api: 0,
      get_bandwidth_api: 0,
      bandwidth: "",
      muvi_one: "3D28C83C85544F0D9517DD2E7C7EEDAA",
      enterprise_api_gateway_url: "",
      api_gateway_url: "",
      logger_url: process.env.REACT_APP_ANALYTICS,
      logger_enterprise_url: process.env.REACT_APP_STARRTLOG,
      shouldRerender: false,
      //api_gateway_url: 'https://apigateway.muvi.com',
      //logger_url: "https://analytics.muvi.com/data/getbySQL/",
      //logger_enterprise_url: "https://starrrtlogs.muvi.com/data/getbySQL/",
    };
  }
  decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
  }

  decrypt(findresponse, flg) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  }
  updateBillingDetails() {
    var appToken = this.props.app_token; //"TeeoXC2ql1M1KFQTAoW33e4LwSGjRgOz";
    const type = this.state.billing_details.account_status.toLowerCase();

    fetch(
      `${process.env.REACT_APP_CRM}/cron/get-crm-billings?type=${type}&update=3&app_token=${appToken}`
    )
      .then((response) => response.json())
      .then((result) => {
        if (result && result.code === 200) {
          this.setState({
            shouldRerender: true,
          });
        }
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }

  //getBillingDetails(storeKey,productKey,appToken) {
  getBillingDetails() {
    const { products } = this.props;

    let enterprise_api_gateway_url;

    if (products && products.is_enterprise) {
      enterprise_api_gateway_url = products.enterprise_api_gateway_url;
      this.setState({
        api_gateway_url: enterprise_api_gateway_url,
      });
    } else {
      enterprise_api_gateway_url = process.env.REACT_APP_APIGETWAY; //"https://apigateway-staging.muvistaging.com";
      this.setState({
        api_gateway_url: enterprise_api_gateway_url,
      });
    }
    var productKey = this.props.product_key;
    var appToken = this.props.app_token;
    var storeKey = this.props.store_key;
    var customer_id = this.props.customer_id;
    const debug = this.props.isDebug;

    let columnsfetch = {
      app_token: customer_id,
      product_key: productKey,
      debug,
    };

    if (productKey === "3D28C83C85544F0D9517DD2E7C7EEDAA") {
      columnsfetch = {
        ...columnsfetch,
        store_key: storeKey,
      };
    }
    const compressedPostData = debug
      ? JSON.stringify(columnsfetch)
      : pako.gzip(JSON.stringify(columnsfetch));
    fetch(process.env.REACT_APP_CRM + "/muvi6/get-billing-details", {
      method: "POST",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug
          ? buffer
          : actionFunction.decompressjsondata(buffer);
        console.log(findresponse, 7343424343247);
        if (findresponse && findresponse.code === 200) {
          this.setState({
            ...this.state,
            billing_details: findresponse.data,
            applications: findresponse.data.subscribed_plans
              ? findresponse.data.subscribed_plans.applications
              : "",
            get_billing_api: 1,
          });
        } else {
          this.setState((state) => {
            return {
              ...state,
              billing_details: {},
              applications: [],
            };
          });
        }
      }) /*
			.then((Response) => Response.json())
			.then((findresponse) => {
				if (findresponse.code == 200) {
					this.setState({
						billing_details: findresponse.data,
						applications: findresponse.data.subscribed_plans ? findresponse.data.subscribed_plans.applications : "",
						get_billing_api: 1,
					});
				}
			})*/
      .then(() => {
        const isApiTrue = this.props.isApi;
        if (isApiTrue) {
          this.updateBillingDetails();
        }
      })
      .then(() => {
        this.getCardDetails();
      })
      .then(() => {
        this.getContentDetails();
      })
      .then(() => {
        this.getBandwidthDetails();
      })
      .then(() => {
        this.getTemplateDetails();
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }
  getCardDetails() {
    const debug = this.props.isDebug;
    let columnsfetch = {
      app_token: this.props.app_token,
      product_key: this.props.product_key,
      user_uuid: this.props.user_uuid,
      debug,
    };

    if (this.props.product_key === "3D28C83C85544F0D9517DD2E7C7EEDAA") {
      columnsfetch = {
        ...columnsfetch,
        store_key: this.props.store_key,
      };
    }
    /*{
      query: `{cards ( app_token:"${this.props.app_token}", product_key:"${this.props.product_key}", user_uuid:"${this.props.user_uuid}", store_key:"${this.props.store_key}" ) { page_info { total_count } cards_list { card_uuid name brand masked_card is_primary last4 created_date last_transaction_date } }}`,
    }*/
    this.setState((state) => {
      return {
        ...state,
        cardisLoading: true,
      };
    });
    const compressedPostData = debug
      ? JSON.stringify(columnsfetch)
      : pako.gzip(JSON.stringify(columnsfetch));

    fetch(process.env.REACT_APP_CRM + "/muvi6/cards", {
      method: "POST",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug
          ? buffer
          : actionFunction.decompressjsondata(buffer);
        if (findresponse && findresponse.code === 200) {
          this.setState({
            cards_list: findresponse.data.cards.cards_list,
            cardisLoading: false,
          });
        }
      }) /*
			.then((Response) => Response.json())
			.then((findresponse) => {
				if (findresponse.code == 200) {
					this.setState({
						cards_list: findresponse.data.cards.cards_list,
					});
				}
			})*/
      .catch((error) => {
        console.error("Fetch error:", error.message);
        // Handle fetch error
      });
  }
  formatBytes(bytes) {
    if (!+bytes) return "0.00 B";
    var size = "GB";
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} ${size}`;
  }

  getTemplateDetails() {
    if (this.props.product_key == this.state.muvi_one) {
      const debug = this.props.isDebug;
      let columnsfetch = {
        app_token: this.props.app_token,
        debug,
      };
      const compressedPostData = debug
        ? JSON.stringify(columnsfetch)
        : pako.gzip(JSON.stringify(columnsfetch));
      fetch(
        process.env.REACT_APP_CRM + "/muvi6/frontend/get-account-template",
        {
          method: "POST",
          body: compressedPostData,
        }
      )
        .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
        .then((buffer) => {
          const findresponse = debug
            ? buffer
            : actionFunction.decompressjsondata(buffer);
          if (findresponse && findresponse.code === 200) {
            this.setState({
              template: findresponse.data.template_name,
              get_template_api: 1,
            });
          }
        }) /*
				.then((Response) => Response.json())
				.then((findresponse) => {
					if (findresponse.code == 200) {
						this.setState({
							template: findresponse.data.template_name,
							get_template_api: 1,
						});
					}
				})*/
        .catch((error) => {
          console.error("Fetch error:", error.message);
          // Handle fetch error
        });
    } else {
      this.setState({
        get_template_api: 0,
      });
    }
  }

  formatBytes(bytes) {
    if (!+bytes) return "0.00 B";
    var size = "GB";
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} ${size}`;
  }

  getBandwidthDetails() {
    const firstdate = moment().startOf("month").format("YYYY-MM-DD");
    const debug = this.props.isDebug;
    let bodyParams = {
      product_key: this.props.product_key,
      app_token: this.props.app_token,
      created_date: firstdate,
      debug,
    };
    const compressedPostData = debug
      ? JSON.stringify(bodyParams)
      : pako.gzip(JSON.stringify(bodyParams));
    fetch(process.env.REACT_APP_CRM + "/muvi6/get-bandwidth", {
      method: "POST",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug
          ? buffer
          : actionFunction.decompressjsondata(buffer);
        if (findresponse && findresponse.code === 200) {
          var total_bandwidth = this.formatBytes(
            findresponse.result[0].total_bandwidth
          );
          this.setState({
            bandwidth: total_bandwidth,
            get_bandwidth_api: 1,
          });
        }
      }) /*
			.then((Response) => Response.json())
			.then((findresponse) => {
				if (findresponse.code == 200) {
					var total_bandwidth = this.formatBytes(findresponse.result[0].total_bandwidth);
					console.log(total_bandwidth, "BAndwith Adta");
					this.setState({
						bandwidth: total_bandwidth,
						get_bandwidth_api: 1,
					});
				}
			})*/
      .catch((error) => {
        console.error("Fetch error:", error.message);
        // Handle fetch error
      });
  }
  getContentDetails() {
    const debug = this.props.isDebug;
    let columnsfetch = {
      app_token: this.props.app_token,
      product_key: this.props.product_key,
      debug,
    };

    if (this.props.product_key === "3D28C83C85544F0D9517DD2E7C7EEDAA") {
      columnsfetch = {
        ...columnsfetch,
        store_key: this.props.store_key,
      };
    }
    /**
    {
        query: `{contentAnalytics(app_token:"${this.props.app_token}", product_key:"${this.props.product_key}", store_key:"${this.props.store_key}"){total_content,total_storage_consumption}}`,
      }
     */
    const compressedPostData = debug
      ? JSON.stringify(columnsfetch)
      : pako.gzip(JSON.stringify(columnsfetch));
    fetch(process.env.REACT_APP_CRM + "/muvi6/content/content-analytics", {
      method: "POST",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug
          ? buffer
          : actionFunction.decompressjsondata(buffer);
        if (findresponse && findresponse.code === 200) {
          this.setState({
            content_analytics: findresponse.data.contentAnalytics,
            get_content_api: 1,
          });
        }
      }) /*
			.then((Response) => Response.json())
			.then((findresponse) => {
				if (findresponse.code == 200) {
					this.setState({
						content_analytics: findresponse.data.contentAnalytics,
						get_content_api: 1,
					});
				}
			})*/
      .catch((error) => {
        console.error("Fetch error:", error.message);
        // Handle fetch error
      });
  }

  getRecentAccount() {
    if (this.state.get_billing_api == 1) {
      return (
        <div>
          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
              <div
                class="single-product"
                style={{
                  marginBottom: "10px",
                }}
              >
                <div class="top-text">Cancelled By</div>
                <div class="bottom-text">
                  {this.state.billing_details.cancellation
                    ? this.state.billing_details.cancellation.canceled_by
                    : "NA"}
                </div>
              </div>
            </div>
            <div class="col-lg-8 col-md-6 col-sm-6 col-xs-12">
              <div
                class="single-product"
                style={{
                  marginBottom: "10px",
                }}
              >
                <div class="top-text">Cancellation Reason</div>
                <div class="bottom-text">
                  {this.state.billing_details.cancellation
                    ? this.state.billing_details.cancellation.reason
                    : "NA"}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
              <div
                class="single-product"
                style={{
                  marginBottom: "10px",
                }}
              >
                <div class="top-text">Cancellation Date</div>
                <div class="bottom-text">
                  {this.state.billing_details.cancellation
                    ? new Date(
                      this.state.billing_details.cancellation.date
                    ).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })
                    : "NA"}
                </div>
              </div>
            </div>
            <div class="col-lg-8 col-md-6 col-sm-6 col-xs-12">
              <div
                class="single-product"
                style={{
                  marginBottom: "10px",
                }}
              >
                <div class="top-text">On hold Period</div>
                <div class="bottom-text">
                  {this.state.billing_details.cancellation
                    ? new Date(
                      this.state.billing_details.cancellation.onhold_period[0]
                    ).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    }) +
                    " - " +
                    new Date(
                      this.state.billing_details.cancellation.onhold_period[1]
                    ).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })
                    : "NA"}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
              <div
                class="single-product"
                style={{
                  marginBottom: "10px",
                }}
              >
                <div class="top-text">Deleted by</div>
                <div class="bottom-text">
                  {this.state.billing_details.deletion
                    ? this.state.billing_details.deletion.deleted_by
                    : "NA"}
                </div>
              </div>
            </div>
            <div class="col-lg-8 col-md-6 col-sm-6 col-xs-12">
              <div
                class="single-product"
                style={{
                  marginBottom: "10px",
                }}
              >
                <div class="top-text">Deletion Date</div>
                <div class="bottom-text">
                  {this.state.billing_details.deletion
                    ? new Date(
                      this.state.billing_details.deletion.date
                    ).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })
                    : "NA"}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
              <div
                class="single-product"
                style={{
                  marginBottom: "10px",
                }}
              >
                <div class="top-text">Blocked</div>
                <div class="bottom-text">
                  {this.state.billing_details.is_blocked == 1 ? "Yes" : "No"}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div class="col-xs-6 col-sm-12 col-md-12 col-lg-12  padding-right mt-3">
          <div
            class="row"
            style={{
              paddingTop: "10px",
            }}
          >
            <Skeleton count={5} />
          </div>
        </div>
      );
    }
  }

  getRecentBilling() {
    if (this.state.get_billing_api == 1) {
      return <span></span>;
    } else {
      return (
        <div class="col-xs-6 col-sm-12 col-md-12 col-lg-12  padding-right mt-3">
          <div
            class="row"
            style={{
              paddingTop: "10px",
            }}
          >
            <Skeleton count={5} />
          </div>
        </div>
      );
    }
  }

  getRecentProduct() {
    if (this.state.get_billing_api == 1) {
      return (
        <div class="ana-account">
          <div class="">
            <div class="single-box">
              <div class="only-text">
                <div class="top-text">Customer Type</div>
                <div class="bottom-text">
                  {" "}
                  {/*this.state.billing_details.account_status ? this.state.billing_details.account_status : "NA"*/}
                  {this.state.billing_details.account_status == "Lead" &&
                    this.state.billing_details.is_demo_account === true
                    ? `${this.state.billing_details.account_status} (Demo)`
                    : this.state.billing_details.account_status}
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="single-box">
              <div class="only-text">
                <div class="top-text">Product</div>
                <div class="bottom-text">
                  {" "}
                  {this.props.products.product_name
                    ? this.props.products.product_name
                    : "NA"}
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="single-box">
              <div class="only-text">
                <div class="top-text">Product Pricing</div>
                <div class="bottom-text">
                  {" "}
                  {this.state.billing_details.subscribed_plans
                    ? "$" +
                    this.state.billing_details.subscribed_plans.platform
                      .base_price
                    : "NA"}
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="single-box">
              <div class="only-text">
                <div class="top-text">Plan Term</div>
                <div class="bottom-text">
                  {" "}
                  {this.state.billing_details.subscribed_plans
                    ? this.state.billing_details.subscribed_plans.platform
                      .interval
                    : "NA"}
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="single-box">
              <div class="only-text">
                <div class="top-text">Product Plan</div>
                <div class="bottom-text">
                  {" "}
                  {this.state.billing_details.subscribed_plans
                    ? this.state.billing_details.subscribed_plans.platform.name
                    : "NA"}
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="single-box">
              <div class="only-text">
                <div class="top-text">Joined On</div>
                <div class="bottom-text">
                  {" "}
                  {this.state.billing_details.created_date
                    ? new Date(
                      this.state.billing_details.created_date
                    ).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })
                    : "NA"}
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="single-box">
              <div class="only-text">
                <div class="top-text">Subscription Started On</div>
                <div class="bottom-text">
                  {this.state.billing_details.first_subsription_date
                    ? new Date(
                      this.state.billing_details.first_subsription_date
                    ).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })
                    : "NA"}
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="single-box">
              <div class="only-text">
                <div class="top-text">Source</div>
                <div class="bottom-text">
                  {this.props.source && this.props.source != "NA" ? (
                    <a
                      href={
                        this.props.source.startsWith("http://") ||
                          this.props.source.startsWith("https://")
                          ? this.props.source
                          : `https://${this.props.source}`
                      }
                      name={"max"}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      {this.props.source}{" "}
                    </a>
                  ) : (
                    "NA"
                  )}
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="single-box">
              <div class="only-text">
                <div class="top-text">Applications</div>
                <div class="bottom-text">
                  {this.state.applications.length > 0
                    ? this.state.applications.map((data, key) => (
                      <span>
                        {data.name}
                        {key !== this.state.applications.length - 1
                          ? ", "
                          : ""}
                      </span>
                    ))
                    : "NA"}
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="single-box">
              <div class="only-text">
                <div class="top-text">Free Trial Expires On</div>
                <div class="bottom-text">
                  {" "}
                  {this.state.billing_details.free_trial_expiry_date
                    ? new Date(
                      this.state.billing_details.free_trial_expiry_date
                    ).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })
                    : "NA"}
                </div>
              </div>
            </div>
          </div>
          {this.getTemplate()}
        </div>
      );
    } else {
      return (
        <div class="col-xs-6 col-sm-12 col-md-12 col-lg-12  padding-right mt-3">
          <div
            class="row"
            style={{
              paddingTop: "10px",
            }}
          >
            <Skeleton count={5} />
          </div>
        </div>
      );
    }
  }

  getRecentCards() {
    if (this.state.cardisLoading) {
      return (
        <div class="col-xs-6 col-sm-12 col-md-12 col-lg-12  padding-right mt-3">
          <div
            class="row"
            style={{
              paddingTop: "10px",
            }}
          >
            <Skeleton count={5} />
          </div>
        </div>
      );
    }
    if (this.state.cards_list.length > 0) {
      return (
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6">
          <div
            class="single-product"
            style={{
              marginBottom: "10px",
            }}
          >
            <div class="top-text">Card Details</div>
            <div class="bottom-text">
              {this.state.cards_list.map((data, key) => (
                <span>
                  {" "}
                  {data.masked_card.slice(-4)}
                  {key !== this.state.cards_list.length - 1 ? ", " : ""}
                </span>
              ))}
            </div>
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }

  getRecentBandwidth() {
    return (
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6">
        <div
          class="single-box"
          style={{
            marginBottom: 0,
            padding: "5px 0px",
          }}
        >
          <div class="icon-box">
            {/* icon and colour change */}
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <g clip-path="url(#clip0_568_330)">
                <mask id="mask0_568_330" maskUnits="userSpaceOnUse" x="0" y="1" width="17" height="14">
                  <path d="M8.6633 2C4.78063 2 1.6333 5.14733 1.6333 9.03C1.6333 10.8683 2.23542 12.6983 3.3908 13.951H13.9358C15.0908 12.6983 15.6933 10.8683 15.6933 9.03C15.6933 5.14733 12.546 2 8.6633 2Z" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.66332 11.4907C9.43984 11.4907 10.0693 10.8612 10.0693 10.0847C10.0693 9.3082 9.43984 8.67871 8.66332 8.67871C7.88681 8.67871 7.25732 9.3082 7.25732 10.0847C7.25732 10.8612 7.88681 11.4907 8.66332 11.4907Z" fill="white" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.66337 6.56932V8.67832M8.66337 3.75732V4.46032M3.39087 9.38132H4.09387M4.79687 5.86632L5.29389 6.36334M13.2329 9.38132H13.9359M12.1784 6.36334L12.6754 5.86632" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                </mask>
                <g mask="url(#mask0_568_330)">
                  <path d="M-0.0462036 -0.460449H17.1773V16.4116H-0.0462036V-0.460449Z" fill="#006EFA" />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_568_330">
                  <rect width="16" height="15.6735" fill="white" transform="translate(0.633301)" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div
            class="only-text"
            style={{
              marginLeft: 0,
            }}
          >
            <div class="top-text">Bandwidth Used This Month</div>
            <div class="bottom-text">
              {this.state.get_bandwidth_api == 1 ? this.state.bandwidth : "0"}
            </div>
          </div>
        </div>
      </div>
    );
  }

  getRecentContent() {
    if (this.state.get_content_api == 1) {
      return (
        <React.Fragment>
          <div>
            <div class="single-box">
              <div class="icon-box">
                {/* icon and colour change */}
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                  <g clip-path="url(#clip0_568_322)">
                    <path d="M14.44 10.5934C14.0159 11.5964 13.3525 12.4802 12.5079 13.1676C11.6633 13.855 10.6632 14.325 9.59495 14.5366C8.52673 14.7481 7.42294 14.6948 6.38009 14.3813C5.33724 14.0677 4.38708 13.5034 3.61267 12.7378C2.83827 11.9722 2.2632 11.0286 1.93775 9.98935C1.6123 8.95015 1.54637 7.84704 1.74572 6.77647C1.94508 5.70591 2.40366 4.70047 3.08136 3.84807C3.75906 2.99567 4.63525 2.32226 5.63333 1.88672" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14.9667 8.00016C14.9667 7.12468 14.7942 6.25778 14.4592 5.44894C14.1242 4.6401 13.6331 3.90517 13.014 3.28612C12.395 2.66706 11.66 2.176 10.8512 1.84097C10.0424 1.50593 9.17547 1.3335 8.29999 1.3335V8.00016H14.9667Z" fill="#006EFA" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_568_322">
                      <rect width="16" height="16" fill="white" transform="translate(0.299988)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div class="only-text">
                <div class="top-text">Storage</div>
                <div class="bottom-text">
                  {" "}
                  {this.state &&
                    this.state.content_analytics &&
                    this.state.content_analytics.total_storage_consumption || "0"}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="single-box">
              <div class="icon-box">
                {/* icon and colour change */}
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                  <g clip-path="url(#clip0_568_330)">
                    <mask id="mask0_568_330" maskUnits="userSpaceOnUse" x="0" y="1" width="17" height="14">
                      <path d="M8.6633 2C4.78063 2 1.6333 5.14733 1.6333 9.03C1.6333 10.8683 2.23542 12.6983 3.3908 13.951H13.9358C15.0908 12.6983 15.6933 10.8683 15.6933 9.03C15.6933 5.14733 12.546 2 8.6633 2Z" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M8.66332 11.4907C9.43984 11.4907 10.0693 10.8612 10.0693 10.0847C10.0693 9.3082 9.43984 8.67871 8.66332 8.67871C7.88681 8.67871 7.25732 9.3082 7.25732 10.0847C7.25732 10.8612 7.88681 11.4907 8.66332 11.4907Z" fill="white" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M8.66337 6.56932V8.67832M8.66337 3.75732V4.46032M3.39087 9.38132H4.09387M4.79687 5.86632L5.29389 6.36334M13.2329 9.38132H13.9359M12.1784 6.36334L12.6754 5.86632" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                    </mask>
                    <g mask="url(#mask0_568_330)">
                      <path d="M-0.0462036 -0.460449H17.1773V16.4116H-0.0462036V-0.460449Z" fill="#006EFA" />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_568_330">
                      <rect width="16" height="15.6735" fill="white" transform="translate(0.633301)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div class="only-text">
                <div class="top-text">Bandwidth Used This Month</div>
                <div class="bottom-text">
                  {this.state.get_bandwidth_api == 1
                    ? this.state.bandwidth
                    : "NA"}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="single-box">
              <div class="icon-box">
                {/* icon and colour change */}
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                  <path d="M10.9667 2H13.6333C13.987 2 14.3261 2.14048 14.5762 2.39052C14.8262 2.64057 14.9667 2.97971 14.9667 3.33333V12.6667C14.9667 13.0203 14.8262 13.3594 14.5762 13.6095C14.3261 13.8595 13.987 14 13.6333 14H10.9667" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M7.63333 11.3332L10.9667 7.99984L7.63333 4.6665" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M10.9667 8H2.96667" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="only-text">
                <div class="top-text">Count of Logins</div>
                <div class="bottom-text">
                  {this.props.number_of_login
                    ? this.props.number_of_login
                    : "0"}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="single-box">
              <div class="icon-box">
                {/* icon and colour change */}
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                  <path d="M10.9667 2H13.6333C13.987 2 14.3261 2.14048 14.5762 2.39052C14.8262 2.64057 14.9667 2.97971 14.9667 3.33333V12.6667C14.9667 13.0203 14.8262 13.3594 14.5762 13.6095C14.3261 13.8595 13.987 14 13.6333 14H10.9667" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M7.63333 11.3332L10.9667 7.99984L7.63333 4.6665" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M10.9667 8H2.96667" stroke="#006EFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="only-text">
                <div class="top-text">Number of SubAdmin</div>
                <div class="bottom-text">
                  {" "}
                  {this.props.products &&
                    (this.props.products.subadmin_count ||
                      this.props.products.subadmin_count === 0)
                    ? this.props.products.subadmin_count
                    : "0"}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="single-box">
              <div class="icon-box">
                {/* icon and colour change */}
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="none">
                  <path d="M13.0191 10.8259V9.73222C13.0191 9.15211 12.7886 8.59576 12.3784 8.18557C11.9682 7.77537 11.4119 7.54492 10.8318 7.54492H6.45719C5.87709 7.54492 5.32074 7.77537 4.91054 8.18557C4.50034 8.59576 4.2699 9.15211 4.2699 9.73222V10.8259" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.64445 5.3575C9.85246 5.3575 10.8317 4.37822 10.8317 3.17021C10.8317 1.9622 9.85246 0.98291 8.64445 0.98291C7.43644 0.98291 6.45715 1.9622 6.45715 3.17021C6.45715 4.37822 7.43644 5.3575 8.64445 5.3575Z" fill="#006EFA" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M16.3 10.8256V9.73193C16.2997 9.2473 16.1384 8.77651 15.8414 8.39348C15.5445 8.01045 15.1288 7.73688 14.6595 7.61572" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M2.57093 7.58797L1.7972 8.36089C1.45459 8.70366 1.23551 9.1505 1.17437 9.63126C1.11323 10.112 1.2135 10.5995 1.45941 11.0171" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12.4722 1.0542C12.9427 1.17467 13.3597 1.4483 13.6575 1.83195C13.9553 2.21561 14.117 2.68747 14.117 3.17314C14.117 3.65882 13.9553 4.13068 13.6575 4.51433C13.3597 4.89799 12.9427 5.17162 12.4722 5.29209" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M4.39563 5.30273C3.9304 5.16332 3.52479 4.87303 3.24277 4.47764C2.96074 4.08224 2.81833 3.60422 2.83799 3.11895C2.85765 2.63367 3.03826 2.16874 3.35135 1.79745C3.66444 1.42617 4.0922 1.16964 4.56718 1.06832" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="only-text">
                <div class="top-text">Number of Users</div>
                <div class="bottom-text">
                  {" "}
                  {this.props.products && this.props.products.total_no_of_users
                    ? this.props.products.total_no_of_users
                    : "0"}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="single-box">
              <div class="icon-box">
                {/* icon and colour change */}
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                  <g clip-path="url(#clip0_568_366)">
                    <path d="M8.62567 13.8695C8.71798 14.4112 8.91029 14.9153 9.17952 15.3743H3.17182C2.31798 15.3743 1.63336 14.7047 1.63336 13.8695V1.83142C1.63336 1.43233 1.79545 1.04959 2.08397 0.767395C2.37248 0.485197 2.7638 0.32666 3.17182 0.32666H9.32567L13.9411 4.84095V8.67057C13.6872 8.63295 13.4334 8.60285 13.1718 8.60285C12.9103 8.60285 12.6564 8.63295 12.4026 8.67057V5.59333H8.55644V1.83142H3.17182V13.8695H8.62567ZM11.6334 10.1076L9.71029 12.3648H10.8641V15.3743H12.4026V12.3648H13.5564L11.6334 10.1076ZM15.4795 13.8695V10.86H13.9411V13.8695H12.7872L14.7103 16.1267L16.6334 13.8695H15.4795Z" fill="#006EFA" />
                  </g>
                  <defs>
                    <clipPath id="clip0_568_366">
                      <rect width="16" height="16" fill="white" transform="translate(0.633301)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div class="only-text">
                <div class="top-text">Total Content Uploaded</div>
                <div class="bottom-text">
                  {" "}
                  {this.state && 
                    this.state.content_analytics &&
                      this.state.content_analytics.total_content || "0"}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="single-box">
              <div class="icon-box">
                {/* icon and colour change */}
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                  <g clip-path="url(#clip0_568_373)">
                    <path d="M12.3 14V12.6667C12.3 11.9594 12.019 11.2811 11.5189 10.781C11.0189 10.281 10.3406 10 9.63333 10H4.3C3.59275 10 2.91448 10.281 2.41438 10.781C1.91428 11.2811 1.63333 11.9594 1.63333 12.6667V14" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.96668 7.33333C8.43944 7.33333 9.63335 6.13943 9.63335 4.66667C9.63335 3.19391 8.43944 2 6.96668 2C5.49393 2 4.30002 3.19391 4.30002 4.66667C4.30002 6.13943 5.49393 7.33333 6.96668 7.33333Z" fill="#006EFA" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M16.3 13.9998V12.6664C16.2996 12.0756 16.1029 11.5016 15.7409 11.0346C15.3789 10.5677 14.8721 10.2341 14.3 10.0864" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M11.6333 2.08643C12.2069 2.23329 12.7154 2.56689 13.0784 3.03463C13.4415 3.50237 13.6386 4.07765 13.6386 4.66976C13.6386 5.26187 13.4415 5.83715 13.0784 6.30489C12.7154 6.77262 12.2069 7.10623 11.6333 7.25309" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_568_373">
                      <rect width="16" height="16" fill="white" transform="translate(0.966675)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div class="only-text">
                <div class="top-text">Number of Subscribers</div>
                <div class="bottom-text">
                  {" "}
                  {this.props.products &&
                    this.props.products.total_no_of_subscribed_users
                    ? this.props.products.total_no_of_subscribed_users
                    : "0"}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="single-box">
              <div class="icon-box">
                {/* icon and colour change */}
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                  <g clip-path="url(#clip0_568_384)">
                    <path d="M15.6734 13.4074H15.1302V2.54321C15.1302 2.39914 15.073 2.26097 14.9711 2.1591C14.8693 2.05723 14.7311 2 14.587 2H10.7846C10.6405 2 10.5023 2.05723 10.4004 2.1591C10.2986 2.26097 10.2413 2.39914 10.2413 2.54321V5.25926H6.98209C6.83802 5.25926 6.69985 5.31649 6.59798 5.41836C6.49611 5.52023 6.43888 5.6584 6.43888 5.80247V8.51852H3.17962C3.03555 8.51852 2.89738 8.57575 2.79551 8.67762C2.69364 8.77949 2.63641 8.91766 2.63641 9.06173V13.4074H2.0932C1.94913 13.4074 1.81096 13.4646 1.70909 13.5665C1.60722 13.6684 1.54999 13.8066 1.54999 13.9506C1.54999 14.0947 1.60722 14.2329 1.70909 14.3347C1.81096 14.4366 1.94913 14.4938 2.0932 14.4938H15.6734C15.8175 14.4938 15.9557 14.4366 16.0576 14.3347C16.1594 14.2329 16.2167 14.0947 16.2167 13.9506C16.2167 13.8066 16.1594 13.6684 16.0576 13.5665C15.9557 13.4646 15.8175 13.4074 15.6734 13.4074ZM7.5253 6.34568H10.2413V13.4074H7.5253V6.34568ZM3.72283 9.60494H6.43888V13.4074H3.72283V9.60494Z" fill="#006EFA" />
                  </g>
                  <defs>
                    <clipPath id="clip0_568_384">
                      <rect width="16" height="16" fill="white" transform="translate(0.299988)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div class="only-text">
                <div class="top-text">Collected Revenue</div>
                <div class="bottom-text">
                  {" "}
                  {this.state.billing_details.revenue_from_user
                    ? this.getRevenue()
                    : 0}
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <div class="col-xs-6 col-sm-12 col-md-12 col-lg-12  padding-right mt-3">
          <div
            class="row"
            style={{
              paddingTop: "10px",
            }}
          >
            <Skeleton count={5} />
          </div>
        </div>
      );
    }
  }

  componentDidMount() {
    document.title = "Intranet | Customer Details";
    if (!localStorage.getItem("userLogin")) {
      this.setState({ redirect: true });
    }
    //console.log("props", this.props);
    //this.getCardDetails();
    //this.getBillingDetails();
    //this.getContentDetails();
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if the data prop has changed
    if (this.props.product_key !== prevProps.product_key) {
      // Data has changed, call your API
      this.getBillingDetails();
    }
    if (this.props.account_manager !== this.state.account_manager) {
      this.props.getAccountManager(this.state.account_manager);
    }
    if (this.state.shouldRerender !== prevState.shouldRerender) {
      // Reset the rerender flag to prevent continuous rerendering
      this.setState({ shouldRerender: false });
    }
  }

  getTemplate() {
    return (
      <div className="">
        <div class="single-box">
          <div class="only-text">
            <div class="top-text">Template</div>
            <div class="bottom-text">
              {this.state.get_template_api ? this.state.template : "NA"}
            </div>
          </div>
        </div>
      </div>
    );
  }

  getRevenue() {
    if (this.state.billing_details.revenue_from_user.length > 0) {
      return (
        <div className="bottom-text">
          {this.state.billing_details.revenue_from_user[0].amount.toFixed(2)}
        </div>
        // <select class="form-control customer_form-control">
        //   {this.state.billing_details.revenue_from_user.map((currency, key) => (
        //     <option value="">
        //       {currency.currency_symbol} {currency.amount.toFixed(2)}
        //     </option>
        //   ))}
        // </select>
      );
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/login"} />;
    }

    return (
      <React.Fragment>
        <div class="product-tab chat">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ul class="nav nav-tabs" role="tablist">
                {this.props.productArray &&
                  this.props.productArray.map((data, key) => (
                    <li
                      role="presentation"
                      className={key === 0 ? "active" : ""}
                      key={key}
                    >
                      <a
                        href="#one"
                        aria-controls="one"
                        role="tab"
                        data-toggle="tab"
                        aria-expanded="true"
                        onClick={() => this.props.handleTabClick(data)}
                      >
                        {data.product_name ? data.product_name : "NA"}
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          <div class="tab-content" style={{ paddingTop: "10px" }}>
            <div role="tabpanel" class="tab-pane active" id="one">
              <div class="row">
                <div class="col-xs-12">
                  <div class="title">Product</div>
                  {this.getRecentProduct()}
                </div>
                <div class="col-xs-12">
                  <div class="seperator"></div>
                </div>
                <div class="col-xs-12">
                  <div class="title">Analytics</div>
                  <div class="analitcs">{this.getRecentContent()}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-area">
          <div class="product-area revenue-area">
            <div class="title">Revenue &amp; Billing</div>
            <div class="row">
              <div class="col-lg-4 col-md-12 col-sm-6 col-xs-12">
                <div class="single-product">
                  <div class="top-text">Last Paid Amount</div>
                  <div class="bottom-text">
                    {this.state.billing_details.last_transaction_amount ||
                      this.state.billing_details.last_transaction_amount == 0
                      ? "$" + this.state.billing_details.last_transaction_amount
                      : "NA"}
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-sm-6 col-xs-12">
                <div class="single-product">
                  <div class="top-text">Mode of payment</div>
                  <div class="bottom-text">
                    {" "}
                    {this.state.billing_details.payment_type
                      ? this.state.billing_details.payment_type
                      : "NA"}
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-sm-6 col-xs-12">
                <div class="single-product">
                  <div class="top-text">Subscription Started On</div>
                  <div class="bottom-text">
                    {this.state.billing_details.first_subsription_date
                      ? new Date(
                        this.state.billing_details.first_subsription_date
                      ).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })
                      : "NA"}
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-sm-6 col-xs-12">
                <div class="single-product">
                  <div class="top-text">Revenue Last 30Days</div>
                  <div class="bottom-text">
                    {this.state.billing_details.revenue_last_month ||
                      this.state.billing_details.revenue_last_month == 0
                      ? "$" + this.state.billing_details.revenue_last_month
                      : "NA"}
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-sm-6 col-xs-12">
                <div class="single-product">
                  <div class="top-text">Revenue Lifetime</div>
                  <div class="bottom-text">
                    {this.state.billing_details.revenue_lifetime ||
                      this.state.billing_details.revenue_lifetime == 0
                      ? "$" + this.state.billing_details.revenue_lifetime
                      : "0"}
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-sm-6 col-xs-12">
                <div class="single-product">
                  <div class="top-text">Last Transaction Date</div>
                  <div class="bottom-text">
                    {this.state.billing_details.last_transaction_date
                      ? new Date(
                        this.state.billing_details.last_transaction_date
                      ).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })
                      : "NA"}
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-sm-6 col-xs-12">
                <div class="single-product">
                  <div class="top-text">Next Subscription Billing Date</div>
                  <div class="bottom-text">
                    {this.state.billing_details.next_subsription_date
                      ? new Date(
                        this.state.billing_details.next_subsription_date
                      ).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })
                      : "NA"}
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-sm-6 col-xs-12">
                <div class="single-product">
                  <div class="top-text">Next Infra Billing Date</div>
                  <div class="bottom-text">
                    {this.state.billing_details.next_infra_billing_date
                      ? new Date(
                        this.state.billing_details.next_infra_billing_date
                      ).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })
                      : "NA"}
                  </div>
                </div>
              </div>
              {/* <div class="col-lg-4 col-md-12 col-sm-6 col-xs-12">
                  <div class="single-product">
                    <div class="top-text">Next Infra Billing Date</div>
                    <div class="bottom-text">
                      {this.state.billing_details.next_infra_billing_date
                        ? new Date(
                            this.state.billing_details.next_infra_billing_date
                          ).toLocaleDateString("en-US", {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                          })
                        : "NA"}
                    </div>
                  </div>
                </div> */}
              {this.getRecentCards()}
            </div>
          </div>

          <div class="product-area account-area-six">
            <div class="title">Account</div>
            <div class="row">{this.getRecentAccount()}</div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ProductStoreDetailsNew;



// WEBPACK FOOTER //
// ./src/components/crm/customer/ProductStoreDetailsNew.js